import { render, staticRenderFns } from "./TreeSelect.vue?vue&type=template&id=f8c96ca6&scoped=true"
import script from "./TreeSelect.vue?vue&type=script&lang=js"
export * from "./TreeSelect.vue?vue&type=script&lang=js"
import style0 from "./TreeSelect.vue?vue&type=style&index=0&id=f8c96ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c96ca6",
  null
  
)

export default component.exports